// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"SearchPage-Wrapper-2u5Npv","Input":"SearchPage-Input-164SRn"};